module.exports = __webpack_public_path__ + "static/media/icon2_7.ca3be387.svg";